import { APIErrorResponse, isAPIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

import Identity from './identity';
import { headers } from './constants';

/**
 * Resets a password by passing in a new password and the valid nonce that was communicated to the user. Returns 200 on success
 *
 * @param nonce One time token communicated to the user via an event.
 * @param newPassword
 *
 * @returns
 * A __Promise__ which resolves to `true` if successful.
 *
 * <details>
 * <summary>
 * On Success (resolves)
 * </summary>
 *
 * ```
 * true
 * ```
 * </details>
 *
 * <details>
 * <summary>
 * On error (throws)
 * </summary>
 *
 * ```
 * See documentation for corresponding error codes:
 * https://redirector.arcpublishing.com/alc/docs/swagger/?url=./arc-products/arc-identity-v1.json#/User_Registration/resetPasswordWithNonce
 * ```
 * </details>
 *
 */
export default function resetPassword(
  nonce: string,
  newPassword: string
): Promise<boolean | APIErrorResponse> {
  return fetch(`${Identity.apiOrigin}/identity/public/v1/password/reset/${nonce}`, {
    method: 'PUT',
    headers,
    body: JSON.stringify({ newPassword })
  })
    .then(JSONResponseHandler)
    .then(json => {
      if (isAPIErrorResponse(json)) {
        throw json;
      } else {
        return true;
      }
    });
}
